@if (content.title) {
  <div>
    <div class="skymiles-landing-page-quick-links">
      <h3>{{ content.title }}</h3>
      <div class="skymiles-landing-page-quick-links__card">
        @for (card of content.cards; track $index) {
          <idp-card
            (notify)="clickAnalytics(card, $index)"
            [contents]="card"
          ></idp-card>
        }
      </div>
    </div>
  </div>
}
